export default function iconPathURL(imgPath) {
  const srcPath = process.env.PUBLIC_URL + "/assets/images/" + imgPath;
  return srcPath;
}
